const safetyFeature = [
  {
    brkey: "",
    inspectionId: "",
    safetyFeatureType: "1",
    controlFeature: "0",
    location: "",
    updateDateTime: "",
    sfDesc: "",
    updateUserId: "",
  },
  {
    brkey: "",
    inspectionId: "",
    safetyFeatureType: "2",
    controlFeature: "0",
    location: "",
    updateDateTime: "",
    sfDesc: "",
    updateUserId: "",
  },
  {
    brkey: "",
    inspectionId: "",
    safetyFeatureType: "3",
    controlFeature: "0",
    location: "",
    updateDateTime: "",
    sfDesc: "",
    updateUserId: "",
  },
  {
    brkey: "",
    inspectionId: "",
    safetyFeatureType: "4",
    controlFeature: "0",
    location: "",
    updateDateTime: "",
    sfDesc: "",
    updateUserId: "",
  },
];
export default safetyFeature;
